export const fileTransfer = `
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 113.79 122.88">
  <defs>
    <style>
      .cls-1 {
        fill-rule: evenodd;
      }
    </style>
  </defs>
  <title>upload-file</title>
  <path class="cls-1" d="M65.59,67.32h38.82a9.41,9.41,0,0,1,9.38,9.38v36.79a9.41,9.41,0,0,1-9.38,9.39H65.59a9.41,9.41,0,
  0,1-9.38-9.39V76.7a9.41,9.41,0,0,1,9.38-9.38ZM60,11.56,79.73,30.07H60V11.56ZM20.87,54a2.14,2.14,0,0,0-2,2.23,2.12,
  2.12,0,0,0,2,2.23H59.65a2.14,2.14,0,0,0,2-2.23,2.1,2.1,0,0,0-2-2.23Zm0,16a2.14,2.14,0,0,0-2,2.23,2.1,2.1,0,0,0,2,
  2.22H45.67V70Zm0,16a2.14,2.14,0,0,0-2,2.23,2.1,2.1,0,0,0,2,2.23H45.67V85.91Zm0-47.89a2.14,2.14,0,0,0-2,2.23,2.11,
  2.11,0,0,0,2,2.23H43.81a2.14,2.14,0,0,0,2-2.23,2.11,2.11,0,0,0-2-2.23Zm0-16a2.14,2.14,0,0,0-2,2.23,2.1,2.1,0,0,0,
  2,2.23h12.6a2.14,2.14,0,0,0,2-2.23,2.11,2.11,0,0,0-2-2.23ZM90.72,32.72a3.28,3.28,0,0,0-2.39-3.17L59.23,1.21A3.27,
  3.27,0,0,0,56.69,0H5.91A5.91,5.91,0,0,0,0,5.91V107.12A5.91,5.91,0,0,0,5.91,113H45.76v-6.6H6.61V6.57H53.37V33.36a3.32,
  3.32,0,0,0,3.32,3.31H84.12V58.29h6.6V32.72Zm6.45,65.1a2.4,2.4,0,0,0,
  2.06-1c1.08-1.62-.4-3.22-1.42-4.35-2.91-3.19-9.49-9-10.92-10.66a2.37,2.37,0,0,0-3.72,0c-1.49,1.73-8.43,
  7.86-11.19,11-1,1.08-2.15,2.56-1.15,4a2.42,2.42,0,0,0,2.07,1h5.17v9.27A2.92,2.92,0,0,0,81,110H89.1A2.92,
  2.92,0,0,0,92,107.09V97.82Z" />
</svg>
`;
